export const DailySuggestedPrompts = {
  WhoAreYou: 'Who are you? and what can i do in Daydic app? give me the list of features.',
  SuggestAcademicDictionary: 'Suggest an academic dictionary for pharmacy',
  SuggestEnglishVocabulary: 'Give me a dictionary about driver license vocabulary in italian.',
  SuggestTravelConversation: 'I want to travel to germany. What are your dictionary suggestions?',
  CreateTravelConversation:
    "I'm practicing French. Create a dictionary of food names in French to English for me. (10 words)",
} as const

export const NoteSuggestedPrompts = {
  CreateTravelNote:
    'Create a note for my trip to germany. in german language level A2. it should cover most valuable sentences in travel.',
  CreateCommunicationNote:
    'Generate a note for basic communication in a restaurant. in french language level A1.',
  CreateEngineeringNote: 'Create a structured note about engineering thermodynamics.',
  CreatePharmacyNote:
    'Generate a note about common pharmaceutical terms. in english language level B2.',
}

export const QuizSuggestedPrompts = {
  GeneralQuiz: 'Create a general knowledge quiz.',
  RelationshipQuiz: 'Generate a quiz about relationship phrases in italian.',
  EngineeringQuiz: 'Generate a quiz with 10 questions about chemical engineering (M.Sc).',
  GeographyQuiz: 'Give me some True/False questions about geographical facts.',
}

export const DictionarySuggestedPrompts = {
  AcademicDictionary: 'Create an academic dictionary for pharmacy. English to italian.',
  TravelDictionary:
    'I want to travel to spain. Create a travel dictionary for me as a beginner. english to german.',
  ThematicDictionary:
    'I am seeing a girl in cafe. create a thematic dictionary for cafe conversation. french to english.',
  VocabularyList:
    'Generate a dictionary of animal names in chinese(mandarin) to english. 10 words.',
}

export const FlashCardSuggestedPrompts = {
  CreateFrenchFlashCards:
    'Create flashcards for common French verbs. include infinitive, conjugation, and example sentence.',
  CreateSpanishFlashCards:
    'Generate flashcards for essential Spanish travel phrases. include phrase, pronunciation, and context of use.',
  CreateMedicalFlashCards:
    'Create flashcards for key medical terms in English to German. include term, definition, and example usage.',
  CreateBusinessFlashCards:
    'Generate flashcards for common business vocabulary in English to Japanese. include word, meaning, and example sentence.',
}

export const MatchingGameSuggestedPrompts = {
  CreateFrenchMatchingGame:
    'Create a matching game for common French adjectives and their English meanings. include at least 10 pairs.',
  CreateSpanishMatchingGame:
    'Generate a matching game for essential Spanish nouns and their English translations. include at least 10 pairs.',
  CreateMedicalMatchingGame:
    'Create a matching game for key medical terms in English and their German equivalents. include at least 10 pairs.',
  CreateBusinessMatchingGame:
    'Generate a matching game for common business vocabulary in English and their Japanese counterparts. include at least 10 pairs.',
}

export const FigureSuggestedPrompts = {
  CreateScientificFigure:
    'Create a scientific figure illustrating the water cycle with labeled components.',
  CreateBiologyFigure: 'Generate a figure showing the structure of a plant cell with annotations.',
  CreateChemistryFigure:
    'Create a figure depicting the periodic table of elements with color-coded groups.',
  CreatePhysicsFigure:
    "Generate a figure illustrating Newton's laws of motion with relevant diagrams.",
}
